export default [
  /** 家充桩开始 */
  {
    path: '/jiachongzhuang/home-install',
    name: 'HomeInstall',
    component: () => import('../../views/jiachongzhuang/HomeInstall.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/jiachongzhuang/install-info',
    name: 'InstallInfo',
    component: () => import('../../views/jiachongzhuang/InstallInfo.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/jiachongzhuang/receive-electric-pile',
    name: 'receiveElectricPile',
    component: () => import('../../views/jiachongzhuang/receiveElectricPile'),
    meta: {
      title: '领取家充桩',
    },
  },
  {
    path: '/jiachongzhuang/homeEvaluate',
    name: 'HomeEvaluate',
    component: () => import('../../views/jiachongzhuang/HomeEvaluate.vue'),
    meta: {
      title: '发表评价',
    },
  },
  {
    path: '/jiachongzhuang/homeDetails',
    name: 'HomeDetails',
    component: () => import('../../views/jiachongzhuang/HomeDetails.vue'),
    meta: {
      title: '订单详情',
    },
  },
  {
    path: '/jiachongzhuang/submittedSuccessfully',
    name: 'SubmittedSuccessfully',
    component: () => import('../../views/jiachongzhuang/SubmittedSuccessfully.vue'),
    meta: {
      title: '',
    },
  },
  {
    path: '/jiachongzhuang/map',
    name: 'Map',
    component: () => import('../../views/jiachongzhuang/Map.vue'),
    meta: {
      title: '地图',
    },
  },
  /** 家充桩结束 */
]
